import React, { Component } from 'react';
import moment from 'moment';
import redirectURL from "../redirectURL";
import { Modal } from 'react-bootstrap';
import { getDecoder } from '../common/utils';
import SweetAlert from 'react-bootstrap-sweetalert';
const SSOLogin = React.lazy(() => import("./SSOLogin/login"));

var images = require.context('../../assets/images/', true);

class Samplepage extends Component {

    constructor(props) {
        super(props);
        this.state = {
            style: {},
            showpass: false,
            username: '',
            password: '',
            isNav: false,
            show: false,
            title: '',
            onConfirm: '',
            modelOpen: false,
            oldPassword: '',
            newPassword: '',
            confirmPassword: '',
            showp: false,
            showp2: false,
            showp3: false,
            showAlert: false,
            typeAlert: 'default',
            titleAlert: ''
        };
    }

    cipher = salt => {
        const textToChars = text => text.split('').map(c => c.charCodeAt(0));
        const byteHex = n => ("0" + Number(n).toString(16)).substr(-2);
        const applySaltToChar = code => textToChars(salt).reduce((a, b) => a ^ b, code);

        return text => text.split('')
            .map(textToChars)
            .map(applySaltToChar)
            .map(byteHex)
            .join('');
    }
    decipher = salt => {
        const textToChars = text => text.split('').map(c => c.charCodeAt(0));
        const applySaltToChar = code => textToChars(salt).reduce((a, b) => a ^ b, code);
        return encoded => encoded.match(/.{1,2}/g)
            .map(hex => parseInt(hex, 16))
            .map(applySaltToChar)
            .map(charCode => String.fromCharCode(charCode))
            .join('');
    }
    onSubmitHandler = async (e) => {
        e.preventDefault()
        this.setState({
            show: false,
            style: { display: 'flex' },
            style2: { display: 'none' },
        })
        let md = this.cipher("Z744cRBHMjQTsi6cOlNaRKauSEF6MiEr");
        let r = md(this.state.username)
        let d = md(this.state.password)
        let params = {
            e: r,
            d: d
        }
        await redirectURL.post('/verifyUser', params)
            .then((response) => {
                if (response.data.status == "success") {
                    var decode = this.decipher("Z744cRBHMjQTsi6cOlNaRKauSEF6MiEr");
                    localStorage.setItem("k", response.data.output);
                    var c = moment.parseZone().format("YYYY-MM-DD")
                    var s = moment.parseZone().format("HH:mm:ss")
                    localStorage.setItem("date", c);
                    localStorage.setItem("time", s);
                    localStorage.setItem("dept_code", "SNDG")
                    localStorage.setItem("transportercode", JSON.stringify(["ENM135"]))
                    localStorage.setItem('lastActivityTime', '');
                    localStorage.setItem('logoutuser', '3232343232323');
                    this.setState({
                        isNav: true,
                    })
                }
                else if (response.data.status == "expired") {
                    this.setState({
                        modelOpen: true,
                        style: { display: 'none' },
                        style2: { display: 'block' },
                    })
                }
                else {
                    this.setState({
                        show: true,
                        title: response?.data?.message ?? "Invalid Email / Password.",
                        style: { display: 'none' },
                        style2: { display: 'block' },
                    })
                }
            }).catch(err => console.log(err))
    }

    changeInputHandler = (event) => {
        this.setState({ [event.target.name]: event.target.value });
    }

    componentDidMount() {
        setTimeout(function () {
            this.setState({ style: { display: 'none' } });
        }.bind(this), 1000)
    }
    closeModal = () => {
        this.setState({
            modelOpen: false,
            oldPassword: '',
            newPassword: '',
            confirmPassword: '',
            showp: false,
            showp2: false,
            showp3: false
        })
    }
    changePassword = async (e) => {
        e.preventDefault()
        if (this.state.newPassword !== this.state.confirmPassword) {
            this.setState({
                showAlert: true,
                typeAlert: 'danger',
                titleAlert: "Password's does not match"
            })
        }
        else if (this.state.oldPassword === this.state.confirmPassword) {
            this.setState({
                showAlert: true,
                typeAlert: 'danger',
                titleAlert: "New password cannot be same as old password"
            })
        }
        else if (this.state.newPassword.includes(" ")) {
            this.setState({
                showAlert: true,
                typeAlert: 'danger',
                titleAlert: "New password cannot include spaces"
            })
        }
        else if (this.state.confirmPassword.includes(" ")) {
            this.setState({
                showAlert: true,
                typeAlert: 'danger',
                titleAlert: "Confirm password cannot include spaces"
            })
        }
        else {
            let md = this.cipher("Z744cRBHMjQTsi6cOlNaRKauSEF6MiEr");
            let data = {
                oldPassword: this.state.oldPassword,
                newPassword: this.state.newPassword,
                username: this.state.username
            }
            let params = {
                data: md(JSON.stringify(data))
            }
            await redirectURL.post('/changeUserPassword', params)
                .then((response) => {
                    if (response.data.status == "success") {
                        this.setState({
                            showAlert: true,
                            typeAlert: 'success',
                            titleAlert: response.data.message
                        })
                    }
                    else {
                        this.setState({
                            showAlert: true,
                            typeAlert: 'danger',
                            titleAlert: response.data.message
                        })
                    }
                }).catch(err => console.log(err))
        }
    }

    changeHandler = (event) => {
        var name = event.target.name;
        var value = event.target.value;
        this.setState({
            [name]: value
        })
    }
    onConfirm = () => {
        if (this.state.typeAlert == "success")
            this.closeModal()
        this.setState({
            showAlert: false,
            typeAlert: 'default',
            titleAlert: ''
        })
    }

    render() {
        let style = this.state.style;
        if (localStorage.getItem("k") !== "" && localStorage.getItem("k") !== undefined && localStorage.getItem("k") !== null) {
            const user = getDecoder()
            try {
                if (user.role[0] == "DEALER")
                    window.location.href = '/active-FOs'
                if(user.role[0] == "EXIM")
                    window.location.href = '/active-exim-FOs '
                else
                    window.location.href = '/active-FOs'
            } catch (e) {
                window.location.href = '/active-FOs'
            }
        }

        return (
            <div>
                <SweetAlert
                    show={this.state.showAlert}
                    title={<span style={{ fontSize: "1rem" }}>{this.state.titleAlert}</span>}
                    onConfirm={this.onConfirm}
                    confirmBtnBsStyle={this.state.typeAlert}
                    confirmBtnCssClass="sweetButton"
                    customClass='sweetWidth'
                    type={this.state.typeAlert}>
                </SweetAlert>
                <Modal
                    onHide={this.closeModal}
                    dialogClassName="my-modal"
                    show={this.state.modelOpen}
                    centered>
                    <Modal.Header>
                        <Modal.Title>Change Password</Modal.Title>
                        <div className="btn-box d-flex gap-3">
                            <button type="button" className="btn btn-sm btn-icon btn-outline-primary" data-bs-dismiss="modal" aria-label="Close" onClick={this.closeModal}>
                                <i className="fa fa-times"></i>
                            </button>
                        </div>
                    </Modal.Header>
                    <Modal.Body className="view-task">
                        <form className="" onSubmit={this.changePassword.bind(this)}>
                            <label style={{ fontSize: "13px", color: "#dc3545", marginBottom: "0px" }}>* Your password has expired.</label>
                            <label style={{ fontSize: "13px", color: "#dc3545" }}>* Please update your password to regain access to the portal.</label>
                            <div className="col-xl-12 col-lg-12">
                                <div style={{ display: "flex" }}>
                                    <label style={{ color: "#EB1D54", fontSize: "16px", fontFamily: "Inter" }}>*&nbsp;</label>
                                    <label className="custom-label" style={{ fontSize: "13px" }}>
                                        Current Password
                                    </label>
                                </div>
                                <div className="password-input-wrapper">
                                    <input
                                        className="form-control"
                                        type={(this.state.showp) ? "text" : "password"}
                                        placeholder="Current Password"
                                        name='oldPassword'
                                        onChange={this.changeHandler}
                                        required />
                                    {
                                        this.state.showp ?
                                            <i className="fa fa-eye px-2" onClick={() => this.setState(prev => ({ showp: !prev.showp }))} style={{ cursor: 'pointer' }} /> :
                                            <i className="fa fa-eye-slash px-2" onClick={() => this.setState(prev => ({ showp: !prev.showp }))} style={{ cursor: 'pointer' }} />
                                    }
                                </div>
                            </div>
                            <br />
                            <div className="col-xl-12 col-lg-12">
                                <div style={{ display: "flex" }}>
                                    <label style={{ color: "#EB1D54", fontSize: "16px", fontFamily: "Inter" }}>*&nbsp;</label>
                                    <label className="custom-label" style={{ fontSize: "13px" }}>
                                        New Password
                                    </label>
                                </div>
                                <div className="password-input-wrapper">
                                    <input
                                        className="form-control"
                                        type={(this.state.showp2) ? "text" : "password"}
                                        placeholder="New Password"
                                        name='newPassword'
                                        onChange={this.changeHandler}
                                        pattern="^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^\da-zA-Z]).{10,}$"
                                        title="Password must contain at least 1 lowercase letter, 1 uppercase letter, 1 number, 1 special character and minimum 10 characters"
                                        minLength={10}
                                        required />
                                    {
                                        this.state.showp2 ?
                                            <i className="fa fa-eye px-2" onClick={() => this.setState(prev => ({ showp2: !prev.showp2 }))} style={{ cursor: 'pointer' }} /> :
                                            <i className="fa fa-eye-slash px-2" onClick={() => this.setState(prev => ({ showp2: !prev.showp2 }))} style={{ cursor: 'pointer' }} />
                                    }
                                </div>
                            </div>
                            <br />
                            <div className="col-xl-12 col-lg-12">
                                <div style={{ display: "flex" }}>
                                    <label style={{ color: "#EB1D54", fontSize: "16px", fontFamily: "Inter" }}>*&nbsp;</label>
                                    <label className="custom-label" style={{ fontSize: "13px" }}>
                                        Confirm Password
                                    </label>
                                </div>
                                <div className="password-input-wrapper">
                                    <input
                                        className="form-control"
                                        type={(this.state.showp3) ? "text" : "password"}
                                        placeholder="Confirm Password"
                                        name='confirmPassword'
                                        onChange={this.changeHandler}
                                        pattern="^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^\da-zA-Z]).{10,}$"
                                        title="Password must contain at least 1 lowercase letter, 1 uppercase letter, 1 number, 1 special character and minimum 10 characters"
                                        minLength={10}
                                        required />
                                    {
                                        this.state.showp3 ?
                                            <i className="fa fa-eye px-2" onClick={() => this.setState(prev => ({ showp3: !prev.showp3 }))} style={{ cursor: 'pointer' }} /> :
                                            <i className="fa fa-eye-slash px-2" onClick={() => this.setState(prev => ({ showp3: !prev.showp3 }))} style={{ cursor: 'pointer' }} />
                                    }
                                </div>
                            </div>
                            <br />
                            <div className="button-box txt-center mb-3">
                                <button
                                    className="btn btn-primary"
                                    type='submit'>
                                    Submit
                                </button>
                            </div>
                        </form>
                    </Modal.Body>
                </Modal>
                <div className="loader-wrapper" style={style}>
                    <div className="loader bg-white">
                        <div className="line"></div>
                        <div className="line"></div>
                        <div className="line"></div>
                        <div className="line"></div>
                        <h4>Have a great day at work today <span>&#x263A;</span></h4>
                    </div>
                </div>
                <div className="login-bg">
                    <div style={{ paddingLeft: "3rem", paddingTop: "3rem" }}>
                    </div>
                    <div className="card mt-4 mb-0 login-form">
                        <div className='login-custom'>
                            <h3 className='pb-3'>Login</h3>
                            {(this.state.show) ?
                                <div className="pb-3 alert alert-danger">{this.state.title}</div>
                                : ""}
                            <form className="theme-form" onSubmit={this.onSubmitHandler} >
                                <div className="form-group">
                                    <label className="col-form-label pt-0">Username</label>
                                    <input required type="text" name='username' className="form-control form-control-lg login-textbox" value={this.state.username} onChange={this.changeInputHandler.bind(this)} />
                                </div>
                                <div className="form-group">
                                    <label className="col-form-label">Password</label>
                                    <div className="login-textbox" style={{ display: "flex", alignItems: "center", border: "1px solid #ddd" }}>
                                        <input
                                            className="form-control form-control-lg"
                                            style={{ border: "none" }}
                                            name='password'
                                            type={(this.state.showpass) ? "text" : "password"}
                                            onChange={this.changeInputHandler.bind(this)}
                                            required />
                                        {
                                            this.state.showpass ?
                                                <i className="fa fa-eye px-2" style={{ cursor: 'pointer' }} onClick={() => this.setState(prev => { return { showpass: !prev.showpass } })} /> :
                                                <i className="fa fa-eye-slash px-2" style={{ cursor: 'pointer' }} onClick={() => this.setState(prev => { return { showpass: !prev.showpass } })} />
                                        }
                                    </div>

                                    {/* <label className="col-form-label">Password</label>
                                    <input required type={this.state.showpass ? "text" : "password"} name='password' className="form-control form-control-lg login-textbox" value={this.state.password} onChange={this.changeInputHandler.bind(this)} />
                                    {
                                        this.state.showpass ?
                                            <i className="fa fa-eye eye-icon" style={this.state.show ? { top: "60%" } : {}} onClick={() => this.setState(prev => { return { showpass: !prev.showpass } })} /> :
                                            <i className="fa fa-eye-slash eye-icon" style={this.state.show ? { top: "60%" } : {}} onClick={() => this.setState(prev => { return { showpass: !prev.showpass } })} />
                                    } */}
                                </div>
                                <div className="p-0 " style={{ display: "flex", justifyContent: "end" }}>
                                    <a href='/forgot-password' style={{ color: 'black' }}>Forgot Password?</a>
                                </div>
                                <div className=" login-button">
                                    <button type="submit" className="btn login-textbox" style={{ backgroundColor: "#a064ba", color: "#fff" }}>Login
                                    </button>
                                </div>
                            </form>
                            {window.location.hostname == 'nestle.autometrics.in' ? 
                                <SSOLogin /> :<></> }
                        </div>
                    </div>
                </div>
            </div>

        )
    }
}


export default Samplepage;
